import { Component } from 'react';
import PropTypes from 'prop-types';

import { getBranches } from 'shared/dev/api/actions';
import BranchPicker from './BranchPicker';

import Cookies from 'js-cookie';

class AppBranches extends Component {

  static propTypes = {
    float: PropTypes.oneOf(['left', 'right']).isRequired,
    label: PropTypes.string.isRequired,
  };

  static defaultProps = {
    float: 'left',
  };

  state = {
    currentBranch: Cookies.get('branch', { domain: `.${CONFIG.ROOT_DOMAIN}` }) || 'master',
  };

  loadBranches(query) {
    // istanbul ignore next
    const projectID = 262;
    return getBranches(projectID, query, true);
  }

  changeBranch = branch => {
    Cookies.set('branch', branch.value, { domain: `.${CONFIG.ROOT_DOMAIN}` });
    this.setState({ currentBranch: branch.value });
    window.location.reload();
  };

  render() {

    return (
      <BranchPicker
        { ...this.props }
        currentBranch={ this.state.currentBranch }
        loadBranches={ this.loadBranches }
        changeBranch={ this.changeBranch }
        branchLink={
          <a
            href={ encodeURI(`https://beta.wheniwork.net/cmd/choose?serverBranch=${this.state.currentBranch}&redirect=/`) }>
            Link to branch
          </a>
        }
      />
    );
  }
}

export default AppBranches;
